import DashboardTypes from './DashboardTypes';

export function loadNumberOfViews (data) {
  return {
    type: DashboardTypes.GET_NUMBER_OF_VIEWS_REQUEST,
    payload: data
  };
}

export function loadViewsPerSection (data) {
  return {
    type: DashboardTypes.GET_VIEWS_PER_SECTION_REQUEST,
    payload: data
  };
}

export function loadTop50SearchTerms (data) {
  return {
    type: DashboardTypes.GET_TOP_50_SEARCH_TERMS_REQUEST,
    payload: data
  };
}

export function loadNumberOfUniqueVisitors (data) {
  return {
    type: DashboardTypes.GET_NUMBER_OF_UNIQUE_VISITOR_REQUEST,
    payload: data
  };
}

export function updateView (data) {
  return {
    type: DashboardTypes.UPDATE_VIEW_REQUEST,
    payload: data
  };
}

export function updateUniqueVisitor (data) {
  return {
    type: DashboardTypes.UPDATE_UNIQUE_VISITOR_REQUEST,
    payload: data
  };
}

export function updateSectionView (data) {
  return {
    type: DashboardTypes.UPDATE_SECTION_VIEW_REQUEST,
    payload: data
  };
}
